import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=b9c23446&scoped=true&"
import script from "./copy.vue?vue&type=script&lang=js&"
export * from "./copy.vue?vue&type=script&lang=js&"
import style0 from "./copy.vue?vue&type=style&index=0&id=b9c23446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c23446",
  null
  
)

export default component.exports